/* eslint-disable @typescript-eslint/ban-types */
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import 'date-fns'
import { useForm } from 'react-hook-form'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import moment from 'moment-timezone'
import { Box, Checkbox, FormControlLabel, Grid, FormGroup, FormLabel, FormControl, DialogTitle } from '@mui/material'
import { Check as CheckIcon, Clear as ClearIcon, AddCircle as AddCircleIcon } from '@mui/icons-material'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import Button from '@mui/material/Button'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import DatePicker from '@mui/lab/DatePicker'
import { useHistory } from 'react-router-dom'
import { fetchUsersListByGroupId, addUserData } from '../../actions'
import { RootState } from '../../reducers'
import { useStyles } from './UserProfileStyles'
import { IFormInputs, SentForm, AutoCompCodes, UserQc, UserLicense, UserLicenseCopy } from 'interfaces/user'
import SnackBarAlert from '../HOC/SnackBarAlert'

export function AddUserAccount(props): JSX.Element {
  const user = props?.user
  const classes = useStyles()
  const dispatch = useDispatch()
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(new Date())
  const [userLicense, setuserLicense] = useState<UserLicense[]>([
    { state_code: '', expiry_date: `${moment().add(2, 'months').format('YYYY-MM-DD')}` },
  ])
  const [userQcSettings, setUserQcSettings] = useState<UserQc[]>([{ procedure_code_id: '', qc_percentage: '' }])
  const [processCodes, setProcessCodes] = useState<AutoCompCodes[]>([{ id: 0, value: '' }])
  const [statesVariable, setStates] = useState<string[]>([])
  const [appConfig, setAppConfig] = useState([])
  const [userGroupValue, setUserGroupValue] = useState(null)
  const [userIdValue, setUserIdValue] = useState('')
  const [userResults, setUserResults] = useState<any[]>([])
  const [displayContactInformation, setDisplayContactInformation] = useState(false)
  const [displayDifferentUserButton, setDisplayDifferenetUserButton] = useState(false)
  const [userNames, setUserNames] = useState<string[]>([])
  const [firstName, setFirstName] = useState(null)
  const [credentials, setCredentials] = useState(null)
  const [lastName, setLastName] = useState(null)
  const [phoneNumber, setPhoneNumber] = useState(null)
  const [emailAddress, setEmailAddress] = useState(null)
  const [stateCount, setStateCount] = useState(1)
  const [qcCount, setQcCount] = useState(1)
  const history = useHistory()
  const [isShow, setIsShow] = useState(true)
  const [stateOverride, setStateOveride] = useState(false)
  const [performQc, setPerformQc] = useState(false)
  const [priorityCases, setProrityCases] = useState(false)
  const [medicareCases, setMedicareCases] = useState(false)
  const [multipleClassifiers, setMultipleclassifiers] = useState(false)
  const { data } = useSelector((state: RootState) => state.getUsersListByGroupId)
  const { ad_groups, procedure_codes, states, roles, max_case_load } = useSelector(
    (state: RootState) => state.appConfig,
  )
  const { error, success } = useSelector((state: RootState) => state.addUser)
  const [displayStateError, setDisplayStateError] = useState(false)
  const [displayProcessCodeError, setDisplayProcessCodeError] = useState(false)
  const [isSnack, setIsSnack] = useState(false)
  const [requiredFieldsChanged, setRequiredFieldsChanged] = useState(false)
  const [isDuplicatePc, setIsDuplicatePc] = useState(false)

  const [open, setOpen] = React.useState(false)

  const refinedStates = states.map((value) => value.state_code)

  const handleClose = () => {
    setOpen(false)
  }

  const adRoles = roles.map((value) => value.name)
  const procedureCode = procedure_codes.map((value) => {
    return value.cdx_procedure_code + ' - ' + value.description
  })

  const handleStateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRequiredFieldsChanged(true)
    setStateOveride(event.target.checked)
    setValue('any_state_override', stateOverride)
  }

  const handlePerformQc = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRequiredFieldsChanged(true)
    setPerformQc(event.target.checked)
    setValue('priority_allowed', performQc)
  }

  const handlePriorityCases = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRequiredFieldsChanged(true)
    setProrityCases(event.target.checked)
    setValue('priority_allowed', priorityCases)
  }

  const handleMedicareCases = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRequiredFieldsChanged(true)
    setMedicareCases(event.target.checked)
    setValue('mc_allowed', medicareCases)
  }

  const handleMultipleclassifiers = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRequiredFieldsChanged(true)
    setMultipleclassifiers(event.target.checked)
    setValue('multiple_classifiers_allowed', multipleClassifiers)
  }

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm<IFormInputs>({
    mode: 'onChange',
  })

  const addStateComponent = () => {
    setRequiredFieldsChanged(true)
    setStateCount(stateCount + 1)
    const tempuserLicense = [...userLicense]
    const stateObj: UserLicenseCopy = {
      state_code: '',
      expiry_date: `${moment().add(2, 'months').format('YYYY-MM-DD')}`,
    }
    tempuserLicense.push(stateObj)
    setuserLicense(tempuserLicense)
  }

  const onSubmit = async (data: IFormInputs) => {
    const obj: SentForm = {
      user_id: data.user_id,
      user_roles: data.user_roles,
      first_name: data.first_name,
      last_name: data.last_name,
      phone_number: data?.phone_number ? data.phone_number?.toString() : '',
      user_type: 'internal',
      user_status: true,
      credential: data.credential,
      email_id: data.email_id,
      qc_allowed: data.qc_allowed ? data.qc_allowed : 0,
      user_licenses: userLicense,
      user_qc_settings: userQcSettings,
      priority_allowed: data.priority_allowed ? data.priority_allowed : 0,
      mc_allowed: data.mc_allowed ? data.mc_allowed : 0,
      multiple_classifiers_allowed: data.multiple_classifiers_allowed ? data.multiple_classifiers_allowed : 0,
      max_cases_per_day: data.max_cases_per_day ? data.max_cases_per_day : 0,
      any_state_override: data.any_state_override ? data.any_state_override : 0,
      user_ad_id: data?.email_id,
      lab_os_user_code: data?.lab_os_user_code,
      lab_os_login_id: data?.lab_os_login_id,
    }
    if (!isShow) {
      delete obj.user_licenses
      delete obj.user_qc_settings
    }
    await dispatch(addUserData({ payload: obj, id: props?.user }))
    setIsSnack(true)
    setTimeout(function () {
      history.push('/manager-options')
    }, 2000)
  }

  const handleDateChange = (date, index) => {
    setRequiredFieldsChanged(true)
    setSelectedDate(date)
    const dateStr = moment.tz(date, moment.locale()).format('YYYY-MM-DD').toString()
    setValue('expiry_date', dateStr)
    const state = [...userLicense]
    state[index].expiry_date = dateStr
    setuserLicense(state)
  }

  const selectDifferentUser = () => {
    setDisplayContactInformation(false)
    setUserGroupValue(null)
    setUserIdValue('')
    reset({ user_id: '' })
    setDisplayDifferenetUserButton(false)
  }

  const onUserIdChange = (val) => {
    const lastNameValue = val.replace(/\,.*/, '')
    const filterUserResults = userResults?.filter((value) => {
      return value.last_name == lastNameValue
    })
    setUserIdValue(val)
    if (val) {
      setDisplayDifferenetUserButton(true)
    }
    setValue('user_id', filterUserResults[0]?.user_id)
    setValue('first_name', filterUserResults[0]?.first_name)
    setValue('last_name', filterUserResults[0]?.last_name)
    setValue('email_id', filterUserResults[0]?.email_address)
    setValue('phone_number', filterUserResults[0]?.phone_number)
    setValue('credential', filterUserResults[0]?.credential)
    if (val) {
      setDisplayContactInformation(true)
    }
  }
  useEffect(() => {
    const show = userGroupValue === 'NL_Pathologist' ? true : false
    setIsShow(show)
  }, [userGroupValue])

  useEffect(() => {
    const filteredAdRoles = adRoles.filter(function (value) {
      return value !== 'NL_Licensure' && value !== 'NL_QC'
    })
    setAppConfig(filteredAdRoles)
    setProcessCodes(procedure_codes)
    setStates(refinedStates)
    if (data?.length > 0) {
      setUserResults(data)
      const userFirstName = data?.map((value) => value?.last_name + ', ' + value?.first_name)
      setUserNames(userFirstName)
    } else return setUserNames([])
  }, [ad_groups, data, dispatch, procedure_codes, states, user.user_id])

  const onReset = (e) => {
    if (requiredFieldsChanged) {
      setOpen(true)
    } else {
      reset({ user_id: '' })
      history.push('/manager-options')
    }
  }

  const handleConfirm = () => {
    reset({ user_id: '' })
    history.push('/manager-options')
  }

  const onUserGroupChange = (val) => {
    const arr: string[] = []
    arr.push(val)
    setUserGroupValue(val)
    dispatch(fetchUsersListByGroupId({ groupId: val }))
    setValue('user_roles', arr)
  }

  const onCodeChange = (val, index) => {
    setRequiredFieldsChanged(true)
    const filterProcedureCodes = procedure_codes.filter((value) => {
      return value.cdx_procedure_code == val?.substring(0, 3).trim()
    })
    if (val === null) {
      setDisplayProcessCodeError(true)
    } else {
      setValue('procedure_code_id', filterProcedureCodes[0]?.id)
      const processCode = [...userQcSettings]
      processCode[index].procedure_code_id = filterProcedureCodes[0]?.id
      setUserQcSettings(processCode)
      const procedureCodeArray = userQcSettings.map((value) => value.procedure_code_id)
      if (procedureCodeArray.length !== new Set(procedureCodeArray).size) {
        setIsDuplicatePc(true)
      } else {
        setIsDuplicatePc(false)
      }
      setDisplayProcessCodeError(false)
    }
  }

  const onQcChange = (val: string, index: number) => {
    setRequiredFieldsChanged(true)
    setValue('qc_percentage', val)
    const qcPercentage = [...userQcSettings]
    qcPercentage[index].qc_percentage = val
    setUserQcSettings(qcPercentage)
  }

  const addQcComponent = () => {
    setRequiredFieldsChanged(true)
    setQcCount(qcCount + 1)
    const tempuserQcSettings = [...userQcSettings]
    const qcObj: UserQc = {
      procedure_code_id: '',
      qc_percentage: '',
    }
    tempuserQcSettings.push(qcObj)
    setUserQcSettings(tempuserQcSettings)
  }

  const removeQcComponent = (e, i) => {
    setRequiredFieldsChanged(true)
    const tempQcSettings = [...userQcSettings]
    tempQcSettings.splice(i, 1)
    setUserQcSettings(tempQcSettings)
    const procedureCodeArray = tempQcSettings.map((value) => value.procedure_code_id)
    if (procedureCodeArray.length !== new Set(procedureCodeArray).size) {
      setIsDuplicatePc(true)
    } else {
      setIsDuplicatePc(false)
    }
    setQcCount(qcCount - 1)
  }

  const dataProcedurecode = (val) => {
    const filterProcedureCodes = procedure_codes.filter((value) => {
      return value.id == val
    })
    if (val == '') {
      return ''
    } else {
      return filterProcedureCodes[0]?.cdx_procedure_code + ' - ' + filterProcedureCodes[0]?.description
    }
  }

  const onStateChange = (val, index) => {
    setRequiredFieldsChanged(true)
    const state = [...userLicense]
    state[index].state_code = val
    setuserLicense(state)
    const filteredState = statesVariable.filter((word) => word !== val)
    setStates(filteredState)
    if (userLicense[index].state_code == null) {
      setDisplayStateError(true)
    } else return setDisplayStateError(false)
  }

  const removeStateComponent = (e, i) => {
    setRequiredFieldsChanged(true)
    const tempuserLicense = [...userLicense]
    tempuserLicense.splice(i, 1)
    setuserLicense(tempuserLicense)
    setStateCount(stateCount - 1)
    const addSelectedState = tempuserLicense.map((value) => value.state_code)
    const filteredStates = refinedStates.filter(function (obj) {
      return addSelectedState && addSelectedState.indexOf(obj) == -1
    })
    setStates(filteredStates)
  }

  const disableButton = displayContactInformation ? false : true

  const disableButtonForPathologist =
    displayStateError ||
    isDuplicatePc ||
    userLicense[0].state_code === '' ||
    userQcSettings[0].procedure_code_id === '' ||
    userQcSettings[0].qc_percentage === '' ||
    displayProcessCodeError
      ? true
      : false

  const disableSubmitButton = userGroupValue === 'NL_Pathologist' ? disableButtonForPathologist : disableButton

  return (
    <React.Fragment>
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          classes={{ paper: classes.discardDialogHeight }}
        >
          <DialogTitle className={classes.dialogTitle}>Discard Changes</DialogTitle>
          <DialogContent className={classes.discardDialogContent}>
            <DialogContentText id="alert-dialog-description">
              You have pending unsaved changes. Do you really want to discard them?
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.buttonActions}>
            <Button
              className={`${classes.btn} ${classes.buttonMargin}`}
              onClick={handleConfirm}
              autoFocus
              endIcon={<CheckIcon />}
            >
              Confirm
            </Button>
            <Button
              className={`${classes.buttonMargin}`}
              onClick={handleClose}
              variant="outlined"
              endIcon={<ClearIcon />}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {isSnack && (
        <SnackBarAlert
          severity={error ? 'error' : 'success'}
          message={error ? 'Failed to create a user' : 'User added successfully'}
        />
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ flexGrow: 1 }}>
          <h3 className={classes.lableViewMrg}>Start by selecting the person you wish to onboard</h3>
          <Grid container spacing={2} className={classes.mT10}>
            <Grid item xs={4}>
              <Autocomplete
                id="combo-box-demo"
                options={appConfig}
                value={userGroupValue}
                onChange={(e, val) => onUserGroupChange(val)}
                disabled={displayContactInformation}
                renderInput={(params) => <TextField {...params} label="Select user role" size="small" />}
              />
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                id="combo-box-demo"
                options={userNames}
                value={userIdValue}
                disableClearable
                disabled={displayContactInformation || userGroupValue === null}
                onChange={(e, val) => onUserIdChange(val)}
                renderInput={(params) => (
                  <TextField {...params} label="Select the user loaded from Active Directory" size="small" />
                )}
              />
            </Grid>
            {displayDifferentUserButton && (
              <Grid item xs={4}>
                <Button
                  color="secondary"
                  onClick={selectDifferentUser}
                  style={{ textDecoration: 'underline', color: '#0A688D', textTransform: 'initial' }}
                >
                  Select a different user
                </Button>
              </Grid>
            )}
          </Grid>
          {displayContactInformation && (
            <div>
              <h3 className={classes.lableViewMrg10}>Contact Information</h3>
              <Grid container spacing={2} className={classes.mT10}>
                <Grid item xs={4}>
                  <TextField
                    style={{ width: '100%' }}
                    inputProps={{
                      style: {
                        padding: 10,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    id="outlined-basic"
                    label="First Name"
                    value={firstName}
                    disabled
                    {...register('first_name')}
                  />
                  {errors.state_code && <p className="errors">{errors.state_code.message}</p>}
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    style={{ width: '100%' }}
                    inputProps={{
                      style: {
                        padding: 10,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    id="outlined-basic"
                    label="Last Name"
                    disabled
                    value={lastName}
                    {...register('last_name')}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    style={{ width: '100%' }}
                    inputProps={{
                      style: {
                        padding: 10,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    id="outlined-basic"
                    label="Credentials"
                    disabled
                    value={credentials}
                    {...register('credential')}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} className={classes.mT10}>
                <Grid item xs={4}>
                  <TextField
                    style={{ width: '100%' }}
                    inputProps={{
                      style: {
                        padding: 10,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    id="outlined-basic"
                    label="Email Address"
                    disabled
                    value={emailAddress}
                    {...register('email_id')}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    style={{ width: '100%' }}
                    inputProps={{
                      style: {
                        padding: 10,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    id="outlined-basic"
                    value={phoneNumber}
                    disabled={displayContactInformation}
                    label="Phone"
                    {...register('phone_number')}
                  />
                </Grid>
              </Grid>
              {isShow && (
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <h3 className={classes.lableViewMrg}>State Licenses</h3>
                    </Grid>
                    <Grid item xs={4} className={classes.mT10}>
                      <Button color="primary" onClick={addStateComponent} endIcon={<AddCircleIcon />}>
                        Add
                      </Button>
                    </Grid>
                  </Grid>
                  {userLicense.map((val, i) => (
                    // eslint-disable-next-line react/jsx-key
                    <Grid key={i} container spacing={2} className={classes.mT10}>
                      <Grid item xs={4}>
                        <Autocomplete
                          id="combo-box-demo"
                          key={`refinedStates${i}`}
                          options={statesVariable}
                          value={val?.state_code || ''}
                          onChange={(_e, val) => onStateChange(val, i)}
                          renderInput={(params) => (
                            <TextField {...params} required label="Select the state" size="small" defaultValue="" />
                          )}
                        />
                        {displayStateError && !val?.state_code && (
                          <p className={classes.error}>Please select the State with Licenses</p>
                        )}
                      </Grid>
                      <Grid item xs={4} className={classes.mpTB0}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <Grid className={classes.customDatepicker}>
                            <DatePicker
                              key={`dates${i}`}
                              label="Expires"
                              value={val.expiry_date || ''}
                              onChange={(newValue) => handleDateChange(newValue, i)}
                              InputProps={{
                                style: {
                                  height: 40,
                                },
                              }}
                              renderInput={(params) => <TextField {...params} />}
                            />
                          </Grid>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={4}>
                        <Button
                          color="primary"
                          key={`remove${i}`}
                          onClick={(e) => removeStateComponent(e, i)}
                          disabled={stateCount === 1}
                          endIcon={<CheckIcon />}
                        >
                          Remove
                        </Button>
                      </Grid>
                    </Grid>
                  ))}
                  <Grid container spacing={2} className={classes.mT20}>
                    <Grid item xs={12} style={{ paddingTop: '0px' }}>
                      <FormControlLabel
                        control={<Checkbox checked={stateOverride} onChange={handleStateChange} color="primary" />}
                        {...register('any_state_override')}
                        label="User can perform state overides"
                        labelPlacement="end"
                      />
                    </Grid>
                  </Grid>
                </>
              )}
              {isShow && (
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <h3 className={classes.lableViewMrg}>Caseload Settings</h3>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} className={classes.mT10}>
                    <Grid item xs={4}>
                      <TextField
                        className={classes.customLableTxt}
                        style={{ width: '100%' }}
                        InputLabelProps={{
                          style: { border: '1px solid red !important' },
                          shrink: true,
                        }}
                        inputProps={{
                          style: {
                            padding: 10,
                          },
                          min: 1,
                          max: max_case_load,
                        }}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault()
                          }
                        }}
                        id="outlined-basic"
                        label="Max cases per day"
                        defaultValue="21"
                        type="number"
                        {...register('max_cases_per_day')}
                      />
                    </Grid>
                  </Grid>
                  <FormControl component="fieldset" className={`${classes.fieldset}`}>
                    <Grid container spacing={2}>
                      <Grid item xs={8}>
                        <h3 className={classes.lableViewMrg}> Procedure Codes</h3>
                      </Grid>
                      <Grid item xs={4} className={classes.mT10}>
                        <Button color="primary" onClick={addQcComponent} endIcon={<AddCircleIcon />}>
                          Add
                        </Button>
                      </Grid>
                    </Grid>
                    <FormGroup row>
                      {userQcSettings.map((val, i) => (
                        // eslint-disable-next-line react/jsx-key
                        <Grid key={i} container spacing={2} className={classes.mT20}>
                          <Grid item xs={4}>
                            <Autocomplete
                              id="combo-box-demo"
                              key={`qcSettingsCode${i}`}
                              value={dataProcedurecode(val?.procedure_code_id)}
                              options={procedureCode}
                              onChange={(e, val) => onCodeChange(val, i)}
                              renderInput={(params) => (
                                <TextField {...params} required label="Select a procedure code" size="small" />
                              )}
                            />
                            {displayProcessCodeError && (
                              <p className={classes.error}>Please select the Procedure Code</p>
                            )}
                          </Grid>
                          <Grid item xs={4}>
                            <TextField
                              className={classes.customLableTxt}
                              style={{ width: '100%' }}
                              inputProps={{
                                style: {
                                  padding: 10,
                                },
                                min: 1,
                                max: 100,
                              }}
                              InputLabelProps={{ shrink: true }}
                              value={val?.qc_percentage || ''}
                              onChange={(e) => onQcChange(e.target.value, i)}
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                  e.preventDefault()
                                }
                              }}
                              key={`qcSettingsPercentage${i}`}
                              type="number"
                              id="outlined-basic"
                              label="QC allocation %"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <Button
                              color="primary"
                              key={`remove${i}`}
                              onClick={(e) => removeQcComponent(e, i)}
                              disabled={qcCount === 1}
                              endIcon={<ClearIcon />}
                            >
                              Remove
                            </Button>
                          </Grid>
                        </Grid>
                      ))}
                      {isDuplicatePc && <p className={classes.error}>Please remove duplicate Procedure Code</p>}
                    </FormGroup>
                  </FormControl>
                </>
              )}
              {isShow && (
                <>
                  <Grid container spacing={2} className={classes.mp0}>
                    <h3 className={classes.lableViewMrg}>Qualifications</h3>
                    <Grid item xs={12} className={classes.mpTB0}>
                      <FormControlLabel
                        control={<Checkbox checked={performQc} onChange={handlePerformQc} color="primary" />}
                        {...register('qc_allowed')}
                        label="User is qualified to perform QC."
                        labelPlacement="end"
                        className={classes.dBlock}
                      />
                      <FormControlLabel
                        control={<Checkbox checked={priorityCases} onChange={handlePriorityCases} color="primary" />}
                        {...register('priority_allowed')}
                        label="User is qualified to accept Priority and/or Hand Hold cases."
                        labelPlacement="end"
                        className={classes.dBlock}
                      />
                      <FormControlLabel
                        control={<Checkbox checked={medicareCases} onChange={handleMedicareCases} color="primary" />}
                        {...register('mc_allowed')}
                        label="User is qualified to process medicare cases"
                        labelPlacement="end"
                        className={classes.dBlock}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={multipleClassifiers}
                            onChange={handleMultipleclassifiers}
                            color="primary"
                          />
                        }
                        {...register('multiple_classifiers_allowed')}
                        label="User is qualified to view multiple classifiers"
                        labelPlacement="end"
                        className={classes.dBlock}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
              {isShow && (
                <>
                  <Grid container spacing={2} className={classes.mp0}>
                    <Grid item xs={12} className={classes.mB10}>
                      <h3 className={classes.lableViewMrg}>LabOS login details</h3>
                    </Grid>
                    <Grid item xs={2} className={classes.mpTB0}>
                      <TextField
                        className={classes.customLableTxt}
                        style={{ width: '100%' }}
                        InputLabelProps={{
                          style: { border: '1px solid red !important' },
                          shrink: true,
                        }}
                        inputProps={{
                          style: {
                            padding: 10,
                          },
                          min: 1,
                        }}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault()
                          }
                        }}
                        id="outlined-basic"
                        label="User Code"
                        type="number"
                        {...register('lab_os_user_code')}
                      />
                    </Grid>
                    <Grid item xs={2} className={classes.mpTB0}>
                      <TextField
                        className={classes.customLableTxt}
                        style={{ width: '100%' }}
                        InputLabelProps={{
                          style: { border: '1px solid red !important' },
                          shrink: true,
                        }}
                        inputProps={{
                          style: {
                            padding: 10,
                          },
                        }}
                        id="outlined-basic"
                        label="Login ID"
                        type="text"
                        {...register('lab_os_login_id')}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
            </div>
          )}

          <Grid container spacing={2} className={`${classes.mT10}, ${classes.mTB20}`}>
            <Grid item xs={6}>
              <Button
                className={!disableSubmitButton ? classes.btn : classes.btn2}
                type="submit"
                color="primary"
                disabled={disableSubmitButton}
                endIcon={<CheckIcon />}
              >
                Submit
              </Button>
              <Button
                variant="outlined"
                className={classes.cancelButton}
                onClick={(e) => onReset(e)}
                endIcon={<ClearIcon />}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </form>
    </React.Fragment>
  )
}
